

































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiWorkerTypeAdd, apiWorkerTypeEdit, apiWorkerTypeDetail } from '@/api/staff'

@Component
export default class WorkerTypeEdit extends Vue {
    form: any = {
      type_name: '',
      type_code: '',
      service_type: 1,
      description: '',
      skill_tags: [],
      qualification_required: 0,
      training_required: 0,
      work_hours_per_day: 8.0,
      base_hourly_rate: 0,
      base_daily_rate: 0,
      progress_payment_ratio: 0,
      sort: 255,
      is_enabled: 1
    }

    rules = {
      type_name: [
        { required: true, message: '请输入工种名称', trigger: 'blur' },
        { max: 100, message: '工种名称不能超过100个字符', trigger: 'blur' }
      ],
      type_code: [
        { required: true, message: '请输入工种编码', trigger: 'blur' },
        { max: 50, message: '工种编码不能超过50个字符', trigger: 'blur' }
      ],
      service_type: [
        { required: true, message: '请选择服务类型', trigger: 'change' }
      ],
      description: [
        { required: true, message: '请输入工种描述', trigger: 'blur' },
        { max: 500, message: '工种描述不能超过500个字符', trigger: 'blur' }
      ]
    }

    activeTab = 'basic'
    loading = false
    skillOptions = ['清洁技能', '维修技能', '沟通能力', '安全意识', '设备操作', '客户服务', '团队合作']

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑工种信息，修改后会影响相关员工的设置。'
        : '温馨提示：新增工种需要完善基本信息、要求设置等内容。'
    }

    handleSubmit () {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.loading = true
          const params = this.isEdit
            ? { id: this.$route.query.id, ...this.form }
            : this.form

          const api = this.isEdit ? apiWorkerTypeEdit : apiWorkerTypeAdd

          api(params).then(() => {
            this.$router.push('/staff/worker-type')
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }

    getWorkerTypeDetail () {
      if (this.isEdit) {
        apiWorkerTypeDetail({ id: this.$route.query.id }).then((res: any) => {
          const data = res || {}
          Object.keys(this.form).forEach(key => {
            if (data[key] !== undefined) {
              this.form[key] = data[key]
            }
          })

          // 处理技能标签
          if (data.skill_tags) {
            try {
              this.form.skill_tags = JSON.parse(data.skill_tags)
            } catch (e) {
              this.form.skill_tags = []
            }
          }
        })
      }
    }

    created () {
      this.getWorkerTypeDetail()

      if (!this.isEdit) {
        // 生成工种编码
        const date = new Date()
        const year = date.getFullYear().toString().slice(-2)
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
        this.form.type_code = `WT${year}${month}${day}${random}`
      }
    }
}
